var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-row-wrapper" },
    [
      _c(
        "a-popover",
        {
          attrs: {
            visible: _vm.selected,
            trigger: "click",
            placement: "left",
            overlayClassName: "no-padding",
          },
          on: {
            visibleChange: function (isVisible) {
              return isVisible ? _vm.onSelected() : _vm.onCanceled()
            },
          },
        },
        [
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _c("SingleFilterEditor", {
                attrs: {
                  "on-closed": _vm.onCanceled,
                  automationAttributePrefix: _vm.automationAttributePrefix,
                  allowedContexts: _vm.allowedContexts,
                },
                model: {
                  value: _vm.clone,
                  callback: function ($$v) {
                    _vm.clone = $$v
                  },
                  expression: "clone",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "filter-row",
              on: {
                contextmenu: function ($event) {
                  $event.preventDefault()
                  return _vm.showContextMenu($event)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "filter-item", class: { active: _vm.selected } },
                [
                  _c("div", { staticClass: "filter-remove" }, [
                    _c(
                      "div",
                      { staticClass: "control-button" },
                      [
                        _c(
                          "md-button",
                          {
                            staticClass: "md-icon-button md-mini",
                            on: {
                              click: function (e) {
                                e.stopPropagation()
                                _vm.onRemoved(_vm.clone.id)
                              },
                            },
                          },
                          [_c("md-icon", [_vm._v("delete_outline")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "filter-icon" },
                    [
                      _c("AttributeIconPreview", {
                        attrs: { attribute: _vm.clone.attribute },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "filter-item-text" }, [
                    _c("span", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.isLocalizedAttribute(_vm.clone.attribute)
                              ? _vm.$t("chatbotv2.attr." + _vm.clone.attribute)
                              : _vm.clone.attribute.startsWith(
                                  "contact_property_"
                                )
                              ? _vm.visitorContactAttributes[
                                  _vm.clone.attribute.replace(
                                    "contact_property_",
                                    ""
                                  )
                                ]
                              : _vm.clone.attribute
                          ) +
                          "\n                    "
                      ),
                    ]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.getOperatorName()) +
                        "\n                    "
                    ),
                    _vm.isPayloadRequired()
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.getAttributeValue()) + " "),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.contextMenuVisible
        ? _c(
            "a-dropdown",
            {
              attrs: { visible: _vm.contextMenuVisible, trigger: [] },
              on: { visibleChange: _vm.onDropdownVisibleChange },
            },
            [
              _c(
                "ul",
                {
                  staticClass: "custom-context-menu",
                  attrs: { slot: "overlay" },
                  slot: "overlay",
                },
                [
                  _c("li", { on: { click: _vm.openEditAttribute } }, [
                    _vm._v("Düzenle"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticStyle: { position: "fixed", "z-index": "9999" },
                style: _vm.contextMenuStyle,
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: "Attribute'ı Elle Düzenle", footer: null },
          on: {
            cancel: function ($event) {
              _vm.editModalVisible = false
            },
          },
          model: {
            value: _vm.editModalVisible,
            callback: function ($$v) {
              _vm.editModalVisible = $$v
            },
            expression: "editModalVisible",
          },
        },
        [
          _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
            _vm._v("Attribute değerini elle girin:"),
          ]),
          _vm._v(" "),
          _c("a-input", {
            attrs: { placeholder: "block.123.result.sessions.buckets.$..*" },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.saveManualAttribute.apply(null, arguments)
              },
            },
            model: {
              value: _vm.manualAttribute,
              callback: function ($$v) {
                _vm.manualAttribute = $$v
              },
              expression: "manualAttribute",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "16px", "text-align": "right" } },
            [
              _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editModalVisible = false
                    },
                  },
                },
                [_vm._v("İptal")]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  staticStyle: { "margin-left": "8px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.saveManualAttribute },
                },
                [_vm._v("Kaydet")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      (_vm.addFilterMode ? _vm.showOperatorSelect : true)
        ? _c(
            "a-select",
            {
              class: { hovered: _vm.groupSelectHovered },
              attrs: { value: _vm.operator },
              on: {
                change: _vm.onOperatorChanged,
                click: function (e) {
                  e.stopPropagation()
                },
                mouseenter: function () {
                  return _vm.selectGroupHoverStateChanged(true)
                },
                mouseleave: function () {
                  return _vm.selectGroupHoverStateChanged(false)
                },
              },
            },
            [
              _c("a-select-option", { attrs: { value: "or" } }, [
                _vm._v(" " + _vm._s(_vm.$t("chatbotv2.or"))),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "and" } }, [
                _vm._v(" " + _vm._s(_vm.$t("chatbotv2.and"))),
              ]),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "filter-row small" },
            [
              _c(
                "a-popover",
                {
                  attrs: {
                    trigger: "click",
                    placement: "left",
                    overlayClassName: "no-padding",
                  },
                  model: {
                    value: _vm.attributePickerVisible,
                    callback: function ($$v) {
                      _vm.attributePickerVisible = $$v
                    },
                    expression: "attributePickerVisible",
                  },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "content" }, slot: "content" },
                    [
                      _c("AutomationAttributePicker", {
                        attrs: {
                          "default-selected": null,
                          pick: _vm.onAttributePicked,
                          "filter-mode": true,
                          automation: _vm.automation,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "add-filter-button" }, [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v(" add "),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("chatbotv2.addFilter")) +
                        "\n            "
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }